// window.parent.br2nl = function (str, replaceMode) {

//   var replaceStr = (replaceMode) ? "\n" : '';
//   // Includes <br>, <BR>, <br />, </br>
//   return str.replace(/<\s*\/?br\s*[\/]?>/gi, replaceStr);
// }


const script = `
<link href="https://cdn.quilljs.com/1.3.6/quill.snow.css" rel="stylesheet">
<script src="https://cdn.quilljs.com/1.3.6/quill.js"></script>
<script>
var Quill = window.Quill
var style = {
	sms_text: {
		fontFamily: "ralewayregular, Arial,sans-serif",
		fontStyle: "normal",
		fontWeight: "normal",
    fontSize: "16px",
    background: "#f9f9f9",
    height:"111px"
  }
}


var imageContainer = document.getElementsByClassName("image-banner");
var loader = document.createElement("div");
var spinner = document.createElement("div");
spinner.className = "spinner"

  loader.style.position = "absolute";
  loader.style.top = "0";
  loader.style.left = "0";
  loader.style.right = "0";
  loader.style.height = "174px";
  loader.style.background = "white";
  loader.style.zIndex = -1;
  loader.style.display = "flex";
  loader.style.alignItems = "center";
  loader.style.justifyContent = "center";
  loader.style.borderRadius="10px";
  loader.appendChild(spinner)

if(imageContainer[0]){
  imageContainer[0].appendChild(loader);
  var cover = document.createElement("div");
  var imagePickerContainer = document.createElement("label");
  imagePickerContainer.innerHTML = "Change Image"
  imagePickerContainer.className = "image-picker"
  cover.className="image-cover"
  cover.appendChild(imagePickerContainer)
  imageContainer[0].appendChild(cover)
  imagePickerContainer.onclick=window.parent.onEmailBannerChange;
  try {
      window.parent.afterImageChange = function(url){
      var imgElement = document.querySelector('img[alt="Feature Image"]') ||  document.querySelector('img[alt="banner"]')
      loader.style.zIndex = 1;
      if(imgElement)imgElement.src = url;
      imgElement.onload = () => {
        loader.style.zIndex = -1;
      }
      window.parent.smsEditorInputChange("confirm-sms","image_url", url)
    }
  }catch(err){
    console.log("Errors:", err);
  }
}

function edit(ele, ignoreFocus) {
    let child = ele.firstChild.localName;
    if(child !== "input" && child !== "textarea"){
      var istextArea;
      var fieldName = "";
      for(let key in  ele.attributes){
        var hylyEdit = ele.attributes[key].nodeName && ele.attributes[key].nodeName.replace('-', '') === "hylyedit";
        if(ele.attributes[key].nodeValue === "sms_text" &&  hylyEdit){
          istextArea = true;
        }
        if(hylyEdit) fieldName = ele.attributes[key].nodeValue
      }
      if(ele.className.includes("event-message-title")){
        fieldName = "schedule_text"
      }

      if(ele.className.includes("event-message-body")){
        fieldName = "sms_text"
        istextArea = true;
      }

          
      var fields = ['sms_text','title_text','schedule_text'];
      if(fields.indexOf(fieldName) === -1)return;
      var value =  ele.innerHTML;
      var input = document.createElement(istextArea ? "textarea" : "input");
      input.className = "editable-input"
      input.value = istextArea ? window.parent.br2nl(String(value).trim(), true) : String(value).trim();
      //input.setSelectionRange(0,0)
      input.style = style[fieldName]
      input.style.fontSize = style[fieldName].fontSize;
      input.style.fontFamily = style[fieldName].fontFamily;
      input.style.color = ele.style.color;
      input.style.fontWeight = style[fieldName].fontWeight;
      input.style.background = style[fieldName].background;
      // input.style.maxHeight = style[fieldName].height;
      // input.style.minHeight = style[fieldName].height;
      input.style.textAlign = istextArea ? "left" : "center"
      input.style.border = "none"
      input.style.width = "100%"
      //input.style.height = "100%"
      input.style.overflow = "hidden"
      input.resis
      ele.padding = 0;
      ele.innerHTML = ""
      ele.appendChild(input);
      if(!ignoreFocus)
      input.focus();

      input.onkeydown=()=>{
        let height = document.getElementById('confirm-message-container').offsetHeight;
        if(window.parent.reloadPreview){
           window.parent.reloadPreview(height)
        }
      }
      
      input.onchange = (evt) => {
  
        if(window.parent.smsEditorInputChange){
          window.parent.smsEditorInputChange("confirm-sms",fieldName, evt.target.value)
        }
        else{
          console.log("callback not found")
        }
      }
      if(istextArea){
        input.style.height = input.scrollHeight + 'px'
        function autoResize() {
            this.style.height = 'auto';
            this.style.height = this.scrollHeight + 'px';
        }
        input.addEventListener('input', autoResize, false);
      }
    }
  }



  

</script>`

const style = (orgColors) => ` 
  .image-banner{
    position:relative;
    max-width:600px;
    width:100%;
    max-height:340px;
        margin-bottom:20px;
  }
  .image-cover{
    display:none;
  }
  .image-banner:hover .image-cover{
    display: flex !important;
    justify-content: center;
    align-content: center;
    align-items: center;
    position: absolute;
    top:0;
    right:0;
    left:0;
    bottom:0;
    background:#f9f9f9e3;
  }

  input[type="file"] {
    display: none;
  }

  .image-picker{
    color: ${orgColors ? orgColors.buttonFontColor : 'white'} !important;
    height: 40px;
    position: relative;
    background: ${orgColors ? orgColors.buttonBackgroundColor : '#26BBED'} !important;
    text-align: center;
    width:200px;
    display:flex;
    align-items:center;
    justify-content:center;
    border-color:${orgColors ? orgColors.buttonBorderColor : '#26BBED'} !important;
    cursor:pointer;
  }

  td{
    position:relative;
  }

  input:focus{
    outline:none;
  }
  textarea{
    resize:none;
  }
  textarea:focus{
    outline:none;
  }

  .event-message-body:hover{
    border-radius: 2px;
  }

  .n-description {
     position:relative;
  }


  // .event-message-body:hover::after {
  //   font:normal normal normal 1em/1 "Nucleo";
  //   content:url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAjCAMAAACw/5reAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAORQTFRF/////f391tbWxsbG4ODg9vb2nZ2dh4eHmZmZhYWFsbGx9PT0mJiYnp6e8/Pz7Ozsk5OTqKio+/v7lpaWn5+f+vr68fHxlJSUpqam/Pz88vLylZWVgoKC5ubm7+/vjo6OtLS0m5ubkZGR7u7u39/fg4OD+Pj4+fn5nJycvb299/f3ycnJ4eHhxcXF2NjYhISE1dXV09PT9fX11NTU0tLSl5eX0dHR0NDQz8/Pmpqazs7Orq6uzc3NkpKSzMzMy8vL3t7eysrKkJCQp6enyMjIvLy85+fni4uLiYmJrKyso6Ojt7e3ZvbLQQAAAQRJREFUeJzN0m1XgjAUwPFrijFBLVGxWCnVRMEiDdFMMdOev//3iYOKd2y97XTf7L/ze7PtDODvJneUL/xmSvFYJaWc1DS9XIHqyWlNYhWj3oiXptk6E+zcohdJXLY7otn1q+skb1jGmmax6+zUoaIBdHuJ9tsSA3DtWD0y4K3nbivWW3LHncW03X27ln/P3c9SlXQzJLwZ6gjZAzbN0A8WkCG20RhZ6POmI5v4ATZFRTb1Q84ekc3YBBs8jQ82Z1POYOGlGbEZbwpNP8ySzXmDZ7p/mRWLMgb5l114dJk1KK2364auBIPyK9Tegn6LeqLB+8Ji9MP+DCXmfH1HBU0C/3B+AOI+GZjsg2z9AAAAAElFTkSuQmCC"); 
  //   position:absolute;
  //   right:20px;
  //   transform: scale(.8);
  // }

  .spinner {
    border: 5px solid #f3f3f3;
    border-radius: 50%;
    border-top: 5px solid #26bbed;
    width: 40px;
    height: 40px;
    -webkit-animation: spin 1s linear infinite; /* Safari */
    animation: spin 1s linear infinite;
  }
  .image-banner .n-event-banner{
    width: 600px !important;
    max-height: 340px !important;
    /* width: 80%; */
    margin: auto !important;

  }
  
  @-webkit-keyframes spin {
    0% { -webkit-transform: rotate(0deg); }
    100% { -webkit-transform: rotate(360deg); }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  }

 
 `

export const makeSMSEditable = (content, orgColors) => {
  if (!content) return ""
  if (content.includes('class="event-message-title"') || content.includes('class="event-message-body"')) {
    content = content.replace(`class="event-message-body"`, 'class="event-message-body" onclick="edit(this)"')
  }
  content = content.replace("</html>", script + " </html>")
  content = content.replace('<style type="text/css">', '<style type="text/css"> ' + style(orgColors))
  return content;
}
